import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import PrepaidPaymentInfo from '@components/prepaid/PrepaidPaymentInfo';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    cardId: string;
}

function ChargePaymentInfo({ cardId }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount } = useContext(PrepaidContext);
    const { data } = useQuery(userPrepaidCardQueries.detail(cardId));

    return (
        <PrepaidPaymentInfo
            amountWon={amount * 10000}
            currentBalance={data?.balance ?? 0}
            amountLabel={t('charge.chargeAmount')}
            totalLabel={t('charge.afterChargeAmount')}
        />
    );
}

export default ChargePaymentInfo;
